import { AcpDeviceService } from 'core';
import { AcpTalkdeskChatbotPlugin } from './talkdesk-chatbot-plugin';
import acpTalkdeskChatbotTemplate from './templates/talkdesk-chatbot.html';

export class AcpTalkdeskChatbotComponentController
  implements nsUtils.NsComponentController {
  private authed: string;
  isPermission: boolean;
  touchpointId: string;

  constructor(
    nsComponentDecorator,
    private acpDeviceService: AcpDeviceService,
    private acpTalkdeskChatbotPlugin: AcpTalkdeskChatbotPlugin
  ) {
    'ngInject';
    nsComponentDecorator(this, this);
  }

  get isAuthed() {
    return this.authed === 'true';
  }

  talkdeskChatBotHandler() {
    this.acpTalkdeskChatbotPlugin.toggle(this.isAuthed);
  }

  handleBeforeUnload = function () {
    if (
      window.talkDeskWebChat &&
      typeof window.talkDeskWebChat.reset === 'function'
    ) {
      try {
        window.talkDeskWebChat.reset();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error resetting Talkdesk chat:', error);
      }
    } else {
      // eslint-disable-next-line no-console
      console.warn(
        'Talkdesk chat widget API (webchat.reset) not found on beforeunload from component.'
      );
    }
  };

  $onInit(): void {
    this.isPermission = this.acpTalkdeskChatbotPlugin.permission;
    //Resetting session post login for sending access_token to Talkdesk
    if (!sessionStorage.getItem('td_chat_reset') && this.authed) {
      window.TalkdeskChatSDK = null;
      window.talkDeskWebChat?.destroy();
      this.acpTalkdeskChatbotPlugin.init();
      sessionStorage.setItem('td_chat_reset', 'true');
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  $onDestroy = function () {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  };

  isShowIcon() {
    return (
      this.isPermission &&
      window.talkDeskWebChat &&
      (this.acpDeviceService.isWeb() ||
        (this.acpDeviceService.isCordova() && this.isAuthed))
    );
  }
}

export const acpTalkdeskChatbotComponent: ng.IComponentOptions = {
  controller: AcpTalkdeskChatbotComponentController,
  controllerAs: 'vm',
  bindings: {
    authed: '@'
  },
  template: acpTalkdeskChatbotTemplate
};
